import React from 'react';
import PropTypes from 'prop-types';
import styles from './SmallButton.css';
import classNames from 'classnames';

const SmallButton = ({children, color = 'transparent', onClick, disabled}) => {
    const buttonClass = classNames({
        [styles.buttonHighlight]: color === 'highlight',
        [styles.buttonTransparent]: color === 'transparent',
        [styles.disabled]: disabled,
    });

    return (
        <button onClick={onClick} className={buttonClass} type="button">
            {children}
        </button>
    );
};

SmallButton.propTypes = {
    children: PropTypes.node.isRequired,
    color: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

export default SmallButton;
